export default "__VITE_ASSET__CVcSOeyp__"